/* eslint-disable max-len */
import { lazy } from 'ice';
import React from 'react';
import { MyComponentType } from '../../component-factory/component-types';
import { ComponentIdEnum } from '../../component-factory/ComponentIdEnum';
import { ConfigHOC } from '../../HOC';
import { ElementConfigType as Props } from '../../store/type';
import style from './InsCardComponent.module.scss';

export const InsCardComponent: MyComponentType<Props> = (props: Props) => {
  const { id, privateSchema } = props;
  return (
    <div id={id} className={`relative overflow-hidden ${style.insCardWrapper}`}>
      <img
        style={{ width: '100%', borderRadius: '5px' }}
        src={`${
          // eslint-disable-next-line max-len
          privateSchema?.firstImg?.[0]?.mediaSrc ||
          'https://cdn.resource.youniverse.cc/d2c-app/qOz9xj08c9KEVx92SdsHe.jpg?image_process=resize,w_800'
        }?image_process=resize,w_600/quality,Q_80/format,webp`}
        alt={privateSchema?.firstImg?.[0]?.alt}
      />
      <div className={`${style.insMask} absolute inset-0 flex flex-col justify-center items-center text-white`}>
        <div className="text-center" style={{ fontSize: `${privateSchema?.fontSize}px` }}>
          {privateSchema?.text || 'insins'}
        </div>
        <div className="flex gap-2">
          <a href={privateSchema?.buttonUrl} target="_blank" rel="noreferrer">
            {privateSchema?.hoverIconImage ? (
              <img
                className="w-6"
                style={{ width: '32px', height: '32px' }}
                src={privateSchema?.hoverIconImage?.[0]?.mediaSrc}
                alt=""
              />
            ) : (
              <svg
                className="icon w-6"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="https://www.w3.org/2000/svg"
                p-id="2543"
                width="32"
                height="32"
              >
                <path
                  d="M512 85.333333c-115.882667 0-130.389333 0.512-175.914667 2.56-45.397333 2.090667-76.416 9.301333-103.552 19.84a209.109333 209.109333 0 0 0-75.605333 49.194667A209.152 209.152 0 0 0 107.733333 232.533333c-10.538667 27.136-17.749333 58.154667-19.84 103.552C85.802667 381.610667 85.333333 396.117333 85.333333 512s0.469333 130.389333 2.56 175.914667c2.090667 45.397333 9.301333 76.416 19.84 103.552a209.194667 209.194667 0 0 0 49.194667 75.605333 209.194667 209.194667 0 0 0 75.605333 49.194667c27.136 10.538667 58.154667 17.749333 103.552 19.84 45.525333 2.048 60.032 2.56 175.914667 2.56s130.389333-0.512 175.914667-2.56c45.397333-2.090667 76.416-9.301333 103.552-19.84a209.152 209.152 0 0 0 75.605333-49.194667 209.152 209.152 0 0 0 49.194667-75.605333c10.538667-27.136 17.749333-58.154667 19.84-103.552 2.048-45.525333 2.56-60.032 2.56-175.914667s-0.512-130.389333-2.56-175.914667c-2.090667-45.397333-9.301333-76.416-19.84-103.552a209.152 209.152 0 0 0-49.194667-75.605333 209.109333 209.109333 0 0 0-75.605333-49.194667c-27.136-10.538667-58.154667-17.749333-103.552-19.84C642.389333 85.845333 627.882667 85.333333 512 85.333333m0 76.885334c113.92 0 127.402667 0.426667 172.373333 2.474666 41.642667 1.92 64.213333 8.832 79.274667 14.677334 19.882667 7.765333 34.133333 17.024 49.066667 31.914666 14.933333 14.933333 24.149333 29.184 31.914666 49.066667 5.802667 15.061333 12.8 37.632 14.677334 79.232 2.048 45.013333 2.474667 58.453333 2.474666 172.416 0 113.92-0.426667 127.402667-2.474666 172.373333-1.92 41.642667-8.874667 64.213333-14.677334 79.274667a132.266667 132.266667 0 0 1-31.914666 49.066667c-14.933333 14.933333-29.184 24.149333-49.066667 31.914666-15.061333 5.802667-37.632 12.8-79.232 14.677334-44.970667 2.048-58.453333 2.474667-172.416 2.474666-113.92 0-127.445333-0.426667-172.373333-2.474666-41.642667-1.92-64.213333-8.874667-79.274667-14.677334a132.181333 132.181333 0 0 1-49.066667-31.914666 132.181333 132.181333 0 0 1-31.914666-49.066667c-5.845333-15.061333-12.8-37.632-14.677334-79.232-2.048-45.013333-2.474667-58.453333-2.474666-172.416 0-113.92 0.426667-127.402667 2.474666-172.373333 1.92-41.642667 8.832-64.213333 14.677334-79.274667 7.765333-19.882667 17.024-34.133333 31.914666-49.066667 14.933333-14.933333 29.184-24.149333 49.066667-31.914666 15.061333-5.845333 37.632-12.8 79.232-14.677334 45.013333-2.048 58.453333-2.474667 172.416-2.474666m0 491.989333a142.208 142.208 0 1 1 0-284.416 142.208 142.208 0 0 1 0 284.416m0-361.301333a219.093333 219.093333 0 1 0 0 438.186666 219.093333 219.093333 0 0 0 0-438.186666m278.954667-8.661334a51.2 51.2 0 1 1-102.4 0 51.2 51.2 0 0 1 102.4 0"
                  fill="#e6e6e6"
                  p-id="2544"
                />
              </svg>
            )}
            {/* <svg
              className="icon w-6"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="https://www.w3.org/2000/svg"
              p-id="2543"
              width="32"
              height="32"
            >
              <path
                d="M512 85.333333c-115.882667 0-130.389333 0.512-175.914667 2.56-45.397333 2.090667-76.416 9.301333-103.552 19.84a209.109333 209.109333 0 0 0-75.605333 49.194667A209.152 209.152 0 0 0 107.733333 232.533333c-10.538667 27.136-17.749333 58.154667-19.84 103.552C85.802667 381.610667 85.333333 396.117333 85.333333 512s0.469333 130.389333 2.56 175.914667c2.090667 45.397333 9.301333 76.416 19.84 103.552a209.194667 209.194667 0 0 0 49.194667 75.605333 209.194667 209.194667 0 0 0 75.605333 49.194667c27.136 10.538667 58.154667 17.749333 103.552 19.84 45.525333 2.048 60.032 2.56 175.914667 2.56s130.389333-0.512 175.914667-2.56c45.397333-2.090667 76.416-9.301333 103.552-19.84a209.152 209.152 0 0 0 75.605333-49.194667 209.152 209.152 0 0 0 49.194667-75.605333c10.538667-27.136 17.749333-58.154667 19.84-103.552 2.048-45.525333 2.56-60.032 2.56-175.914667s-0.512-130.389333-2.56-175.914667c-2.090667-45.397333-9.301333-76.416-19.84-103.552a209.152 209.152 0 0 0-49.194667-75.605333 209.109333 209.109333 0 0 0-75.605333-49.194667c-27.136-10.538667-58.154667-17.749333-103.552-19.84C642.389333 85.845333 627.882667 85.333333 512 85.333333m0 76.885334c113.92 0 127.402667 0.426667 172.373333 2.474666 41.642667 1.92 64.213333 8.832 79.274667 14.677334 19.882667 7.765333 34.133333 17.024 49.066667 31.914666 14.933333 14.933333 24.149333 29.184 31.914666 49.066667 5.802667 15.061333 12.8 37.632 14.677334 79.232 2.048 45.013333 2.474667 58.453333 2.474666 172.416 0 113.92-0.426667 127.402667-2.474666 172.373333-1.92 41.642667-8.874667 64.213333-14.677334 79.274667a132.266667 132.266667 0 0 1-31.914666 49.066667c-14.933333 14.933333-29.184 24.149333-49.066667 31.914666-15.061333 5.802667-37.632 12.8-79.232 14.677334-44.970667 2.048-58.453333 2.474667-172.416 2.474666-113.92 0-127.445333-0.426667-172.373333-2.474666-41.642667-1.92-64.213333-8.874667-79.274667-14.677334a132.181333 132.181333 0 0 1-49.066667-31.914666 132.181333 132.181333 0 0 1-31.914666-49.066667c-5.845333-15.061333-12.8-37.632-14.677334-79.232-2.048-45.013333-2.474667-58.453333-2.474666-172.416 0-113.92 0.426667-127.402667 2.474666-172.373333 1.92-41.642667 8.832-64.213333 14.677334-79.274667 7.765333-19.882667 17.024-34.133333 31.914666-49.066667 14.933333-14.933333 29.184-24.149333 49.066667-31.914666 15.061333-5.845333 37.632-12.8 79.232-14.677334 45.013333-2.048 58.453333-2.474667 172.416-2.474666m0 491.989333a142.208 142.208 0 1 1 0-284.416 142.208 142.208 0 0 1 0 284.416m0-361.301333a219.093333 219.093333 0 1 0 0 438.186666 219.093333 219.093333 0 0 0 0-438.186666m278.954667-8.661334a51.2 51.2 0 1 1-102.4 0 51.2 51.2 0 0 1 102.4 0"
                fill="#e6e6e6"
                p-id="2544"
              />
            </svg> */}
          </a>
          <a
            href={privateSchema?.buttonUrl}
            target="_blank"
            rel="noreferrer"
            className="text-white hover:text-white focus:text-white"
          >
            <svg
              className="icon inline-block mr-1 w-6"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="https://www.w3.org/2000/svg"
              p-id="3942"
              width="32"
              height="32"
            >
              <path
                // eslint-disable-next-line max-len
                d="M32 407.584a279.584 279.584 0 0 1 480-194.944 279.584 279.584 0 0 1 480 194.944 278.144 278.144 0 0 1-113.024 224.512L562.592 892.8a96 96 0 0 1-124.416-1.952l-308.16-270.688A278.976 278.976 0 0 1 32 407.584z"
                p-id="3943"
                fill="#ffffff"
              />
            </svg>
            <span>{privateSchema?.likeCount || 0}</span>
          </a>
          <a
            href={privateSchema?.commentUrl}
            target="_blank"
            rel="noreferrer"
            className="text-white hover:text-white focus:text-white"
          >
            <svg
              className="icon w-6 inline-block"
              style={{ transform: 'scaleX(-1)' }}
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="https://www.w3.org/2000/svg"
              p-id="5619"
              width="32"
              height="32"
            >
              <path
                d="M510.4 145.6c-202.6 0-366.8 159.6-366.8 356.5 0 102.1 44.3 194.2 115 259.2-15.6 23.3-34.4 44.1-56.2 61.4 1.1-0.2 1.7-0.2 1.3 0-7.8 5.3-13.1 14.4-13.1 24.7 0 13.2 8.6 24 20.3 27.9 14.6 2.2 29.4 3.7 44.7 3.7 18.5 0 36.5-1.9 54.2-5h0.1c10.8-2 21.4-4.3 31.7-7.2 26.7-8.2 53.5-20.2 53.5-20.2l8.3-3.8c17.3 6.9 41.1 10.7 60.8 12.8v-0.1c5.5 0.7 10.9 1.1 16.4 1.6 12.4 0.9 20.8 1.1 20.8 1.1v0.1c2.9 0.1 5.9 0.3 8.9 0.3 202.6 0 366.8-159.6 366.8-356.5 0.1-197-164.2-356.5-366.7-356.5z"
                p-id="5620"
                fill="#e6e6e6"
              />
            </svg>
            <span>{privateSchema?.commentCount || 0}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

const ConfigForm = lazy(() => import('../../components-with-definition/InsCardComponentDefinition'));

InsCardComponent.definition = {
  id: ComponentIdEnum.INS_CARD_COMPONENT,
  name: 'ins社媒卡片组件',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/4t-l7QPFFguGEE20uYYkn.png',
  position: 16,
  config: {},
  privateSchema: {},
  category: 'interactive',
  configForm: ConfigHOC(ConfigForm),
};
